document.addEventListener("DOMContentLoaded", function () {
    // ✅ Check if the current URL matches the login page
    if (window.location.href === "https://www.petcentral.ae/account/login") {
        console.log("🔹 Login page detected!");

        // ✅ Find the element and trigger click
        let loginButton = document.querySelector(".header__button.modal-toggle-btn");
        if (loginButton) {
            loginButton.click();
            console.log("✅ Click event triggered on login button.");
        } else {
            console.log("❌ Login button not found.");
        }
    }
});
